import { call, put, takeEvery } from 'redux-saga/effects';
import * as type from '../ActionTypes';
import {
  getMilestoneRecordService,
  getTimesheetRecordService,
  patchTimesheetRecordService,
  postMilestoneRecordService,
  postTimesheetRecordService,
  putMilestoneRecordService,
  putTimesheetRecordService
} from '../../services/timesheet';
import { getErrorMszOnFailure } from '../../helper/utils';

function* getMilestoneRecordsById(payload: any): any {
  try {
    const milestone = yield call(getMilestoneRecordService, payload.payload);
    const pdata = {
      type: milestone.status === 200 ? type.GET_MILESTONE_SUCCESS : type.GET_MILESTONE_FAILURE,
      payload: milestone.status === 200 ? milestone.data : 'Oops, something went wrong!'
    };
    yield put(pdata);
  } catch (e: any) {
    yield put({
      type: type.GET_MILESTONE_FAILURE,
      payload: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}

function* postMilestoneRecords(action: any): any {
  try {
    const milestone = yield call(postMilestoneRecordService, action.payload);
    const pdata = {
      type: milestone.status === 201 ? type.POST_MILESTONE_SUCCESS : type.POST_MILESTONE_FAILURE,
      payload: milestone.status === 201 ? milestone.data : null,
      error:
        milestone.status === 201
          ? null
          : getErrorMszOnFailure(milestone.data) || 'Oops, something went wrong!'
    };

    yield put(pdata);
  } catch (e: any) {
    yield put({ type: type.POST_MILESTONE_FAILURE, message: e.message });
    console.warn(e.message);
  }
}
function* putMilestoneRecords(action: any): any {
  try {
    const milestone = yield call(putMilestoneRecordService, action.id, action.payload);
    const pdata = {
      type: milestone.status === 200 ? type.PUT_MILESTONE_SUCCESS : type.PUT_MILESTONE_FAILURE,
      payload: milestone.status === 200 ? milestone.data : null,
      error:
        milestone.status === 200
          ? null
          : getErrorMszOnFailure(milestone.data) || 'Oops, something went wrong!'
    };

    yield put(pdata);
  } catch (e: any) {
    yield put({ type: type.PUT_MILESTONE_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getTimesheetRecords(payload: any): any {
  try {
    const timesheet = yield call(getTimesheetRecordService, payload);
    const pdata = {
      type: timesheet.status === 200 ? type.GET_TIMESHEET_SUCCESS : type.GET_TIMESHEET_FAILURE,
      payload: timesheet.status === 200 ? timesheet.data : 'Oops, something went wrong!'
    };
    yield put(pdata);
  } catch (e: any) {
    yield put({
      type: type.GET_TIMESHEET_FAILURE,
      payload: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}

function* postTimesheetRecords(action: any): any {
  try {
    const timesheet = yield call(postTimesheetRecordService, action.payload);
    if (timesheet.status === 201) {
      yield put({
        type: type.POST_TIMESHEET_SUCCESS
      });
    } else {
      yield put({
        type: type.POST_TIMESHEET_FAILURE,
        error: timesheet?.data?.error[0] ?? 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({ type: type.POST_TIMESHEET_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* patchTimesheetRecords(action: any): any {
  try {
    const timesheet = yield call(patchTimesheetRecordService, action.payload, action.id);

    if (timesheet.status === 200) {
      yield put({
        type: type.PATCH_TIMESHEET_SUCCESS
      });
    } else {
      yield put({
        type: type.PATCH_TIMESHEET_FAILURE,
        error: timesheet?.data?.error[0] ?? 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({ type: type.PATCH_TIMESHEET_FAILURE, message: e.message });
    console.warn(e.message);
  }
}
function* putTimesheetRecords(action: any): any {
  try {
    const timesheet = yield call(putTimesheetRecordService, action.payload, action.id);
    if (timesheet.status === 200) {
      yield put({
        type: type.PUT_TIMESHEET_SUCCESS
      });
    } else {
      yield put({
        type: type.PUT_TIMESHEET_FAILURE,
        error: timesheet?.data?.error[0] ?? 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({ type: type.PUT_TIMESHEET_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* timesheetSaga() {
  yield takeEvery(type.GET_MILESTONE_REQUEST, getMilestoneRecordsById);
  yield takeEvery(type.POST_MILESTONE_REQUEST, postMilestoneRecords);
  yield takeEvery(type.PUT_MILESTONE_REQUEST, putMilestoneRecords);
  yield takeEvery(type.GET_TIMESHEET_REQUEST, getTimesheetRecords);
  yield takeEvery(type.POST_TIMESHEET_REQUEST, postTimesheetRecords);
  yield takeEvery(type.PATCH_TIMESHEET_REQUEST, patchTimesheetRecords);
  yield takeEvery(type.PUT_TIMESHEET_REQUEST, putTimesheetRecords);
}

export default timesheetSaga;
